<template>
  <div class="mb-8">
    <v-btn
      :outlined="value === 'Yes'"
      :text="value !== 'Yes'"
      @click="value => $emit('input', 'Yes')"
      color="primary"
      data-cy="listFilter-advanced-form-valueInput-yes"
      >Yes</v-btn
    >
    <v-btn
      :outlined="value === 'No'"
      :text="value !== 'No'"
      @click="value => $emit('input', 'No')"
      color="primary"
      data-cy="listFilter-advanced-form-valueInput-no"
      >No</v-btn
    >
  </div>
</template>

<script>
export default {
  props: {
    value: {},
  },
};
</script>
